
import MetricsCard from "./MetricsCard";
import { DollarSign, Briefcase, Users, Clock } from "lucide-react";

const DashboardMetrics = () => {
  return (
    <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-4">
      <MetricsCard
        title="Total Revenue"
        value="$45,231"
        delta={12.5}
        trend="up"
        icon={DollarSign}
        iconColor="text-green-500"
      />
      <MetricsCard
        title="Active Tasks"
        value="24"
        delta={-3.2}
        trend="down"
        icon={Briefcase}
        iconColor="text-blue-500"
      />
      <MetricsCard
        title="Team Members"
        value="8"
        delta={0}
        trend="neutral"
        icon={Users}
        iconColor="text-purple-500"
      />
      <MetricsCard
        title="Hours Tracked"
        value="164"
        delta={8.1}
        trend="up"
        icon={Clock}
        iconColor="text-orange-500"
      />
    </div>
  );
};

export default DashboardMetrics;
